module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrThin.26e237f.eot";